<div class="quick-view-container" [class.drawer-open]="isDrawerOpen">
  <!-- Main Content Area -->
  <div class="main-content">
    <div class="header-bar">
      <div class="header-content">
        <div class="header-left">
          <span class="title">{{ releaseIssue?.title }}</span>
          <small class="text-info m-l-5 description" *ngIf="releaseIssue?.description">{{ releaseIssue.description }}</small>
          <button *ngIf="releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.CompleteNonIssue && releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.Complete && !isChecking" 
              class="text-info update-btn" mat-flat-button [disabled]="isChecking" (click)="checkForUpdates()">
              Check for updates<mat-icon>update</mat-icon>
          </button>
          <button *ngIf="releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.CompleteNonIssue && releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.Complete && isChecking" 
              class="text-info update-btn" mat-flat-button [disabled]="isChecking" (click)="checkForUpdates()">
              Updating...<mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
          </button>
        </div>
        <div class="header-right">
          <ng-container *ngIf="releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.CompleteNonIssue && releaseIssue?.releaseIssueStatus !== releaseIssueStatuses.Complete">
            <button class="text-success action-btn" mat-flat-button (click)="markFixed(true)">
              Complete<mat-icon>check</mat-icon>
            </button>
            <button class="text-success action-btn" mat-flat-button (click)="markFixed(false)">
              Complete - Non Issue<mat-icon>remove_done</mat-icon>
            </button>
          </ng-container>
          <button mat-icon-button (click)="toggleDrawer()" matTooltip="Toggle details panel" class="drawer-toggle-button">
            <mat-icon>{{ isDrawerOpen ? 'keyboard_arrow_right' : 'view_sidebar' }}</mat-icon>
          </button>
          <mat-icon class="link close-icon" (click)="closeDialog()">close</mat-icon>
        </div>
      </div>
    </div>

    <div class="model-container" #modelContainer>
      <!-- Loading overlay for when rendering is in progress -->
      <div *ngIf="renderStatus === 'inProgress'" class="rendering-overlay" fxLayout="column" fxLayoutAlign="center center">
        <mat-spinner diameter="60"></mat-spinner>
        <h3 class="m-t-20">Rendering updated view...</h3>
        <p>This may take a few minutes</p>
      </div>
      
      <!-- Error overlay for when rendering fails -->
      <div *ngIf="renderStatus === 'failed'" class="error-overlay" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h3 class="m-t-10">Rendering failed</h3>
        <p>Please try again later</p>
        <button mat-raised-button color="primary" class="m-t-10" (click)="renderStatus = 'idle'">Dismiss</button>
      </div>
      
      <div *ngIf="quickViewReportedSituLinkParams" class="model-viewer">
        <situ-view-readonly *ngIf="data?.quickViewProductName === productNames.Panorama" 
          [routeParams]="quickViewReportedSituLinkParams" 
          [style.width.px]="viewerWidth" 
          [style.height.px]="viewerHeight">
        </situ-view-readonly>
        <situ-facade-readonly *ngIf="data?.quickViewProductName === productNames.Facade" 
          [routeParams]="quickViewReportedSituLinkParams"
          [style.width.px]="viewerWidth" 
          [style.height.px]="viewerHeight">
        </situ-facade-readonly>
      </div>
    </div>
  </div>

  <!-- Drawer Panel for Release Items -->
  <div class="drawer-panel" [class.open]="isDrawerOpen">
    <div class="drawer-content">
      <!-- Loading indicator -->
      <div *ngIf="isLoadingIssue" class="loading-container" fxLayout="column" fxLayoutAlign="center center">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading issue details...</p>
      </div>

      <!-- Release Items List -->
      <div *ngIf="!isLoadingIssue && releaseIssue && releaseIssue.releaseItems && releaseIssue.releaseItems.length > 0" class="release-items-container">
        <mat-card class="mat-card-inline-sm">
          <mat-card-header class="compact-header">
            <mat-card-title class="compact-title">Affected Homes ({{releaseIssue.releaseItems.length}})</mat-card-title>
          </mat-card-header>
          <mat-card-content class="compact-content">
            <table class="items-table compact-table">
              <thead>
                <tr>
                  <th>Home</th>
                  <th>Master File</th>
                  <th>Options</th>
                  <th>Style Template</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of releaseIssue.releaseItems">
                  <td class="compact-cell">{{item.home || 'N/A'}}</td>
                  <td class="compact-cell">{{item.masterFile || 'N/A'}}</td>
                  <td class="compact-cell">{{item.options || 'N/A'}}</td>
                  <td class="compact-cell">{{item.styleTemplate || 'N/A'}}</td>
                  <td class="compact-cell action-cell">
                    <button *ngIf="item?.latestVersion || item?.higherResVersion" mat-icon-button color="primary" (click)="viewItem(item)" matTooltip="View" class="compact-button">
                      <mat-icon>preview</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- No items message -->
      <div *ngIf="!isLoadingIssue && releaseIssue && (!releaseIssue.releaseItems || releaseIssue.releaseItems.length === 0)" class="no-items-container" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon>info</mat-icon>
        <p>No release items found for this issue.</p>
      </div>
    </div>
  </div>
</div>